import { render, staticRenderFns } from "./countBlock.vue?vue&type=template&id=482e3408&scoped=true&"
import script from "./countBlock.vue?vue&type=script&lang=js&"
export * from "./countBlock.vue?vue&type=script&lang=js&"
import style0 from "./countBlock.vue?vue&type=style&index=0&id=482e3408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e3408",
  null
  
)

export default component.exports